import { useLayoutEffect, useRef, useState } from "react";

import _ from "lodash";
import type { PDFDocumentProxy } from "pdfjs-dist";
import { Document, type DocumentProps, Page } from "react-pdf";

import { A4_HEIGHT, A4_RATIO, A4_WIDTH, PDF_VIEWER_OPTIONS } from "./values";

type PropsType = {
  file: DocumentProps["file"];
  width?: number;
  height?: number;
  scale?: number;
};

export default function PdfViewer({ file, width, height, scale }: PropsType) {
  const [numPages, setNumPages] = useState<number>(0);
  const [realWidth, setRealWitdth] = useState(width || A4_WIDTH);
  const [realHeight, setRealHeight] = useState(height || A4_HEIGHT);
  const container = useRef<HTMLDivElement>(null);

  function loadSuccess(pdf: PDFDocumentProxy | null) {
    setNumPages(pdf?.numPages || 0);
  }

  // we don't use dependencies below since we only call `setRealHeight` / `setRealWidth` conditionallyand we want to get
  // this updated on all layout changes; instead we disable the lint
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => {
    const newWidth = width || container.current?.clientWidth || A4_WIDTH;
    const newHeight =
      height || (container.current?.clientWidth ? container.current?.clientWidth * A4_RATIO : A4_HEIGHT);

    if (realWidth !== newWidth) {
      setRealWitdth(newWidth);
    }

    if (realHeight !== newHeight) {
      setRealHeight(newHeight);
    }
  });

  return (
    <Document options={PDF_VIEWER_OPTIONS} file={file} onLoadSuccess={loadSuccess} inputRef={container}>
      {_.times(numPages, (i) => (
        <div key={i} className="TT-pdf-viewer-page">
          <Page pageNumber={i + 1} width={realWidth} height={realHeight} scale={scale} />

          <p className="TT-pdf-viewer-page-no">Seite {i + 1}</p>
        </div>
      ))}
    </Document>
  );
}
